import "./spinner.scss";

const Spinner = () => {
  return (
    <div className="spinnerOverlay">
      <div className="spinnerContainer">
        <div />
      </div>
    </div>
  );
};

export default Spinner;
